import OrderCargoOrderDetailsComplexRequest from "../../../../api/raily/order/cargo-order/details-complex/order-cargo-order-details-complex.request";
import OrderCargoOrderDetailsComplexParams from "./order-cargo-order-details-complex-params";

const create = (
  params: OrderCargoOrderDetailsComplexParams,
): OrderCargoOrderDetailsComplexRequest => {
  return { orderId: params.orderUuid };
};

const orderCargoOrderDetailsComplexParamsFactory = {
  create,
};

export default orderCargoOrderDetailsComplexParamsFactory;
